/* Amara Oracle birth-month sign-up: pop-up, homepage band (#am-band), cart box (#am-ck).
   Shown once per device: hidden after sign-up, for 14 days after closing the pop-up, for visitors arriving
   from our emails (utm_medium=email), and (via Liquid) for logged-in subscribers. */
(function(){
  var KEY='amSignup', DAY=864e5, path=location.pathname, q=location.search;
  function get(){try{return JSON.parse(localStorage.getItem(KEY))||{}}catch(e){return {}}}
  function set(v){try{localStorage.setItem(KEY,JSON.stringify(v))}catch(e){}}
  var slot=document.getElementById('am-ck-slot'), ct=document.getElementById('am-ck-tpl');
  if(slot&&ct) slot.replaceWith(ct.content.cloneNode(true));
  var pop=document.getElementById('am-pop'), s=get(), justPosted=/[?&]customer_posted=true/.test(q);
  if(/[?&]utm_medium=email/i.test(q)&&!s.done){s={done:Date.now()};set(s);}
  function hideBoxes(){['am-band','am-ck'].forEach(function(id){var e=document.getElementById(id);e&&e.remove()})}
  if(justPosted){
    var p=s.pending||{}; set({done:Date.now()}); hideBoxes();
    if(pop){pop.classList.add('is-done');
      if(p.n){pop.querySelector('[data-sg-name]').textContent=', '+p.n} if(p.m){pop.querySelector('[data-sg-month]').textContent=p.m}
      pop.classList.add('is-open');pop.setAttribute('aria-hidden','false');
      pop.querySelectorAll('[data-sg-close]').forEach(function(b){b.addEventListener('click',function(){pop.classList.remove('is-open');pop.setAttribute('aria-hidden','true')})});}
    return;
  }
  if(s.done){hideBoxes(); pop&&pop.remove(); return;}
  var isHome=path==='/', band=document.getElementById('am-band'), bandVisible=false, lastFocus=null, timer;
  if(band&&'IntersectionObserver' in window){new IntersectionObserver(function(es){bandVisible=es[0].isIntersecting}).observe(band)}
  function open(){var s=get(); if(!pop||bandVisible||s.done||(s.closed&&Date.now()-s.closed<14*DAY)||pop.classList.contains('is-open'))return;
    lastFocus=document.activeElement; pop.classList.add('is-open'); pop.setAttribute('aria-hidden','false');
    var i=pop.querySelector('input:not([type=hidden])'); i&&setTimeout(function(){i.focus({preventScroll:true})},350);}
  function close(){pop.classList.remove('is-open'); pop.setAttribute('aria-hidden','true');
    var s=get(); if(!s.done){s.closed=Date.now(); set(s);} lastFocus&&lastFocus.focus&&lastFocus.focus();}
  if(pop){
    pop.querySelectorAll('[data-sg-close]').forEach(function(b){b.addEventListener('click',close)});
    pop.addEventListener('click',function(e){if(e.target===pop)close()});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&pop.classList.contains('is-open'))close()});
    /* Form errors re-render the page: show the pop-up again so the visitor sees the message. */
    if(pop.querySelector('.am-sg-err')){pop.classList.add('is-open');pop.setAttribute('aria-hidden','false')}
  }
  var blocked=/^\/(cart|checkout|account|challenge)/.test(path), isProduct=/^\/products\//.test(path);
  if(!blocked&&pop){
    timer=setTimeout(open, isProduct?45000:20000);
    document.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<=0)open()});
    var fired=false; window.addEventListener('scroll',function(){if(fired||isProduct||isHome)return;
      var h=document.documentElement; if((h.scrollTop+innerHeight)/h.scrollHeight>0.6){fired=true;open()}},{passive:true});
  }
  /* Submit for real (Shopify customer form). Tag the birth month and remember name/month for the thank-you. */
  document.querySelectorAll('.am-sg-form').forEach(function(f){
    f.addEventListener('submit',function(e){
      if(!f.reportValidity()){e.preventDefault();return;}
      var m=f.querySelector('[name=birth_month]').value, n=f.querySelector('[name="contact[first_name]"]').value.trim(), t=f.querySelector('[name="contact[tags]"]');
      t.value=t.value.replace(/,?birth-month-[a-z]+/g,'')+',birth-month-'+m.toLowerCase();
      var s=get(); s.pending={n:n,m:m}; set(s); clearTimeout(timer);
    });
  });
})();
